








































import { defineComponent, PropType } from '@vue/composition-api';

import { useTeamId } from '@/modules/teamplan/utils/provideTeamId';

import TopicBookmarkDropdownMenu from '@/modules/teamplan/organisms/ProjectBookmarkDropdownMenu/TopicBookmarkDropdownMenu.vue';
import AdvisorSearchUserTopicBookmark from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserTopicBookmark.vue';

import type { Topic } from '@/modules/advisor-search/api/useUsersApi';
import { useAdvisorSearchUserTopic } from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserTopic';

export default defineComponent({
  name: 'AdvisorSearchUserTopic',
  components: {
    TopicBookmarkDropdownMenu,
    AdvisorSearchUserTopicBookmark,
  },
  props: {
    ownId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    userId: {
      type: Number,
      required: true,
    },
    topic: {
      type: Object as PropType<Topic>,
      required: true,
    },
  },
  setup(props) {
    const { price } = useAdvisorSearchUserTopic(props);
    return {
      teamId: useTeamId(),
      price,
    };
  },
});
